import DeleteIcon from '@material-ui/icons/Delete';
import ToolbarItem from 'components/Toolbar/ToolbarItem';
const deleteIcon = React.createElement(DeleteIcon, null);
// @ts-ignore
const ToolbarDeleteItem = React.forwardRef((props, ref) => {
    return React.createElement(ToolbarItem, Object.assign({ ref: ref, icon: deleteIcon, text: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C" }, props));
});
export default React.memo(ToolbarDeleteItem);
